import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Suppress ResizeObserver loop limit exceeded error - MUST be before anything else
const resizeObserverLoopErr = /ResizeObserver loop/;

// This must be set BEFORE React loads to prevent the error overlay
window.addEventListener('error', (e) => {
  if (e.message && resizeObserverLoopErr.test(e.message)) {
    e.stopImmediatePropagation();
    e.stopPropagation();
    e.preventDefault();
    return;
  }
}, true); // Use capture phase to intercept before React

// Override window.onerror synchronously
window.onerror = function (message) {
  if (typeof message === 'string' && resizeObserverLoopErr.test(message)) {
    return true;
  }
  return false;
};

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
